<app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>